import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { CentroCosto } from '@/app/models/interface/centro-costo.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class CentroCostoService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'centro-costo/';

  create(data: Partial<CentroCosto>) {
    return this.http.post<CustomResponse<CentroCosto>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<CentroCosto[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;

          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<CentroCosto>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<CentroCosto>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<CentroCosto>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<CentroCosto>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
